<template>
  <section aria-labelledby="dashboard">
    <h1 id="dashboard">insights</h1>
    <div class="mb-4">
      <span class="text-lg">want more information about your insights? </span>
      <a href="http://calendly.com/bpogany" target="_blank" class="text-lg font-secondary">click here to schedule a meeting with our VP of analytics & insights</a>
    </div>
    <div class="p-5 rounded-xl mx-5 bg-gray-100 flex flex-col items-center">
      <div class="grid gap-5 2xl:grid-cols-4 xl:grid-cols-3 lg:grid-cols-2 sm:grid-cols-1 auto-row-auto">
        <div
          v-if="embeddedViews && !loadingEmbeddedViews"
          :loading="loadingEmbeddedViews"
          v-for="card in embeddedViews"
          :key="card.id"
          role="link"
          class="max-w-xs rounded-xl cursor-pointer border-2 border-solid border-transparent hover:border-blue-400 overflow-hidden aspect-1"
          @click="openReport(card.id)"
        >
          <img :src="card.display_image" :alt="card.display_name" class="rounded-t-xl display-image-fixed-size">
          <div class="flex bg-white justify-between items-center p-4 gap-x-4 xl:text-lg lg:text-base md:text-sm sm:text-sm">
            <div class="whitespace-nowrap">{{card.display_name}}</div>
            <span class="text-blue">view</span>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { mapGetters } from 'vuex';
import RemoveRailsLoadingMixin from '../../mixins/RemoveRailsLoadingMixin';
import UserAbilitiesMixin from '../../mixins/UserAbilitiesMixin';
import { merchantsAPI } from '../../services/api'

export default {
  name: 'DashboardIndex',

  mixins: [RemoveRailsLoadingMixin, UserAbilitiesMixin],

  data() {
    return {
      embeddedViews: [],
      loadingEmbeddedViews: false
    }
  },
  
  created() {
    this.$store.dispatch('LOAD_CURRENT_MERCHANT').then(() => {
      this.removeLoading('campaign-show-loading-icon')
    })
    this.$store.dispatch('LOAD_CURRENT_USER');
    
    this.getEmbeddedViews();
  },

  computed: {
    ...mapGetters(
      ['userAbilitiesValue', 'currentMerchant']
    ),
  },

  methods: {
    openReport(id){
      this.$router.push({ name: 'InsightReport', params: {id} })
    },

    async getEmbeddedViews() {
      this.loadingEmbeddedViews = true;

      try {
        const response = await merchantsAPI.getEmbeddedViews();
        if (response) {
          this.embeddedViews = response.embedded_views
        }
        return this.embeddedViews
      } catch (error) {
        this.error.message = "error, please refresh or contact support";
      } finally {
        this.loadingEmbeddedViews = false;
      }
    }
  }
}
</script>

<style scoped>
#dashboard {
  font-family: 'AileronThin';
  font-size: 2rem;
}
.display-image-fixed-size {
  width: 316px;
  height: 238px;
}
</style>
